module.exports = __webpack_public_path__ + "static/media/Patty Lang Headshot_1708429697084.afa637fe.png";